import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface MarketplaceBreadcrumbProps {
  items: BreadcrumbItem[]
}

export function MarketplaceBreadcrumb({ items }: MarketplaceBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-muted-foreground overflow-x-auto py-2 font-medium">
      <Link to="/" className="flex items-center gap-1 hover:text-foreground transition-colors shrink-0">
        <Home className="h-3.5 w-3.5" />
        <span>Home</span>
      </Link>

      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <div key={index} className="flex items-center gap-2 shrink-0">
            <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/40" />
            {item.href && !isLast ? (
              <Link to={item.href} className="hover:text-foreground transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground font-semibold truncate max-w-[200px] sm:max-w-none">{item.label}</span>
            )}
          </div>
        )
      })}
    </nav>
  )
}
